import React from "react";
import { useTranslation } from "react-i18next";
import { ResourceTypes } from "@planzone/dto";
import { RoleSelection } from "./roleSelection";
import { Props } from "./types";
import styles from "./styles.scss";

function Form({ formData, editForm, submitForm }: Props) {
  const { t } = useTranslation();

  return (
    <div className={styles.projectResourceEditionForm}>
      <div className={styles.section}>
        <h2 className={styles.title}>{t("editResource.name")}</h2>
        <input
          placeholder={t("editResource.namePlaceholder")}
          className={styles.name}
          value={formData.name || ""}
          onChange={({ target }) =>
            editForm({ ...formData, name: target.value })
          }
          onBlur={() => submitForm(formData)}
        />
      </div>
      <div className={styles.section}>
        <h2 className={styles.title}>{t("editResource.inputProfession")}</h2>
        <input
          placeholder={t("editResource.professionPlaceholder")}
          className={styles.profession}
          value={formData.profession || ""}
          onChange={({ target }) =>
            editForm({ ...formData, profession: target.value })
          }
          onBlur={() => submitForm(formData)}
        />
      </div>
      {formData.type !== ResourceTypes.MATERIAL && (
        <div className={styles.section}>
          <h2 className={styles.title}>{t("editResource.inputRole")}</h2>
          <RoleSelection
            placeholder={t("editResource.inputRole")}
            selectedRole={formData.role}
            select={(role) => {
              editForm({ ...formData, role });
              submitForm({ ...formData, role });
            }}
          />
        </div>
      )}
      <div className={styles.section}>
        <h2 className={styles.title}>{t("editResource.inputDescription")}</h2>
        <textarea
          placeholder={t("editResource.descriptionPlaceholder")}
          className={styles.description}
          value={formData.description}
          onChange={({ target }) =>
            editForm({ ...formData, description: target.value })
          }
          onBlur={() => submitForm(formData)}
        />
      </div>
    </div>
  );
}

export { Form };
